import * as types from 'live/redux/actionTypes';
import { RSAA } from 'redux-api-middleware';

const chatEndpoint = 'live/chat';

export const liveChatSetPage = page => ({
  type: types.LIVE_CHAT_SET_PAGE,
  payload: page,
});

export const liveChatUpdateActiveMsg = data => ({
  type: types.LIVE_CHAT_MESSAGE_EDIT,
  payload: data,
});

export const liveChatMessageSave = ({ id, text }) => ({
  [RSAA]: {
    endpoint: chatEndpoint,
    method: id ? 'PUT' : 'POST',
    body: JSON.stringify(id ? { id, text } : { text }),
    types: [
      { type: types.LIVE_CHAT_MESSAGE_REQUEST, meta: { id } },
      { type: types.LIVE_CHAT_MESSAGE_RECEIVE, meta: { id } },
      {
        type: types.LIVE_CHAT_MESSAGE_ERROR,
        meta: { id, errorType: 'discrete' },
      },
    ],
  },
});

export const liveChatLoadMessages = ({ page = 0, size, sort }) => ({
  [RSAA]: {
    endpoint: `${chatEndpoint}?sort=${sort}&size=${size}&page=${page}`,
    method: 'GET',
    types: [
      { type: types.LIVE_CHAT_REQUEST, meta: { page } },
      { type: types.LIVE_CHAT_RECEIVE, meta: { page } },
      { type: types.LIVE_CHAT_ERROR, meta: { page } },
    ],
  },
});

export const liveChatLoadUsers = () => ({
  [RSAA]: {
    endpoint: `${chatEndpoint}/authors`,
    types: [
      types.LIVE_CHAT_USERS_REQUEST,
      types.LIVE_CHAT_USERS_RECEIVE,
      types.LIVE_CHAT_USERS_ERROR,
    ],
  },
});

export const liveChatMessageRate = ({ id, like = true }) => ({
  [RSAA]: {
    endpoint: `${chatEndpoint}/${like === true ? 'like' : 'dislike'}/${id}`,
    method: 'POST',
    types: [
      { type: types.LIVE_CHAT_MESSAGE_RATE_REQUEST, meta: { id, like } },
      { type: types.LIVE_CHAT_MESSAGE_RATE_RECEIVE, meta: { id, like } },
      { type: types.LIVE_CHAT_MESSAGE_RATE_ERROR, meta: { id, like } },
    ],
  },
});

export const liveChatMessageDelete = ({ id }) => ({
  [RSAA]: {
    endpoint: `${chatEndpoint}/${id}`,
    method: 'DELETE',
    types: [
      types.LIVE_CHAT_MESSAGE_DELETE_REQUEST,
      types.LIVE_CHAT_MESSAGE_DELETE_RECEIVE,
      types.LIVE_CHAT_MESSAGE_DELETE_ERROR,
    ],
  },
});
